import { Description, Group, Label, Switch, type SwitchProps } from '@gitbook/spine-react';

export function EnhanceSwitch(props: SwitchProps) {
    return (
        <>
            <Group>
                <Label>Enhance import with AI</Label>
                <Description>
                    Automatically refine and clean up imported content using AI.
                </Description>
            </Group>
            <Switch {...props} />
        </>
    );
}
